import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientDetailsPage } from './patient-details';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    PatientDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientDetailsPage),
    DirectivesModule
  ],
})
export class PatientDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-details/patient-details.module.ts